/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Container, Column, Row } from '../../../../styles/Grid';

import Spacer from '../../../ui/Spacer';
import DotComponent from '../../../ui/DotComponent';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.style';

import ContentBlock from '../ContentBlock';
import { get } from 'lodash';

export class Grid extends SafePureComponent {
  constructor(props) {
    super(props);
  }

  getColumnConfig = dataLength => {
    if (dataLength == 2) {
      return { sm: 6, md: 4, lg: 6 };
    }
    return { sm: 12, md: 4, lg: 4 };
  };

  safeRender() {
    const { blockData } = this.props;
    const blockDataLength = blockData.length;

    return (
      <Spacer customCss={styles.containerSizesShop}>
        <Container css={[styles.itemsContainerCss]}>
          <Row className={`mdsection grid-item-${blockData.length}`}>
            {blockData.map((item, index) => {
              const CTA1Link = get(item, 'Cta1Link', '');
              const CTA1Text = get(item, 'Cta1Text', '');
              const CTA2Link = get(item, 'Cta2Link', '');
              const CTA2Text = get(item, 'Cta2Text', '');
              const Heading = get(item, 'Heading', '');
              const ThemeColour = get(item, 'ThemeColour', '');
              const IconSrc = get(item, 'Icon', '');
              const Checkbox = get(item, 'Checkbox', false);

              return (
                <Column
                  key={`block-${index}`}
                  className={`sec1`}
                  cols={this.getColumnConfig(blockDataLength)}
                >
                  <ContentBlock
                    icon={IconSrc}
                    title={Heading}
                    textColor={ThemeColour}
                    showModal={Checkbox}
                    CTA1={{ link: CTA1Link, text: CTA1Text }}
                    CTA2={{ link: CTA2Link, text: CTA2Text }}
                  />
                </Column>
              );
            })}
          </Row>
        </Container>
      </Spacer>
    );
  }
}

Grid.displayName = 'Shop/Grid';

export default withNamespaces()(Grid);
